import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { of, Observable } from 'rxjs';
import { GwcApiConnService } from './gwc-api-conn.service';
import { InstitutionQualification } from './types/institution-qualification.types';

@Injectable({
	providedIn: 'root'
})
export class GwcApiInstitutionQualificationService {


	constructor(
		private _gwcApiConn: GwcApiConnService
	) {

	}

	public details(institution_qualification_id: string) {
		return this._gwcApiConn.request('GET', ['InstitutionQualification', institution_qualification_id]) as Observable<InstitutionQualification>
	}

	public getByInstitutionId(institution_id: string, params: object = {}): Observable<InstitutionQualification[]> {
		return this._gwcApiConn.request('GET', 'InstitutionQualification', _.merge( { institution_id }, params) ) as Observable<InstitutionQualification[]>
	}	

}